import io from "socket.io-client";
import api from "../services/api";


class SocketWorker {
  constructor(companyId , userId) {
    // ✅ RESTORED: Compatibilidade com ZIP - usar api.defaults.headers.Authorization diretamente
    const sessionToken = api.defaults.headers.Authorization

    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = sessionToken
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  configureSocket() {
    // ✅ ETAPA 2: Enviar token em query (compatibilidade OLD) E auth (robustez)
    const socketOptions = {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      query: { userId: this.userId, token: this.token }
    };
    
    // ✅ ETAPA 2: Adicionar auth.token também (robustez)
    if (this.token) {
      // Remover "Bearer " se existir
      let cleanToken = this.token;
      if (typeof cleanToken === 'string' && cleanToken.toLowerCase().startsWith('bearer ')) {
        cleanToken = cleanToken.substring(7).trim();
      }
      socketOptions.auth = { token: cleanToken };
    }
    
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}`, socketOptions);

    this.socket.on("connect", () => {
      console.log("[SOCKET] socket_connected", {
        event: "socket_connected",
        socket_namespace: this.socket?.nsp || `/${this.companyId}`,
        socket_companyId: this.companyId,
        socket_id: this.socket?.id || null
      });
    });

    this.socket.on("disconnect", () => {
      console.log("[SOCKET] socket_disconnected", {
        event: "socket_disconnected",
        socket_namespace: this.socket?.nsp || `/${this.companyId}`,
        socket_companyId: this.companyId
      });
      this.reconnectAfterDelay();
    });

    this.socket.on("reconnect", (attempt) => {
      console.log("[SOCKET] socket_reconnected", {
        event: "socket_reconnected",
        socket_namespace: this.socket?.nsp || `/${this.companyId}`,
        socket_companyId: this.companyId,
        attempt
      });
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {

    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    this.connect();
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      this.instance = null
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;
